import { defineAction } from '~/prix'
import clientCreateAction from './clientCreate.action.json' with { type: 'json' }
import { z } from 'zod'

const clientCreateDefinition = defineAction({
  ...clientCreateAction,

  input: z.object({
    name: z.string(),
    cnpj: z.union([z.string(), z.number()]),
    abbreviation: z.string(),
    municipalityId: z.number(),
    kind: z
      .enum([
        'municipalHealthSecretariat',
        'stateHealthSecretariat',
        'nationalHealthMinistry',
        'regionalAlliance',
        'communityHospital',
        'publicHospital',
        'privateHospital',
        'mock',
        'civilPolice',
        'federalPolice',
        'militaryPolice',
      ])
      .default('municipalHealthSecretariat'),
    force: z.boolean().default(false),
  }),
  output: z.object({
    id: z.number(),
    message: z.string(),
  }),
})

export default clientCreateDefinition
